import { FC } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { FlexboxGrid } from 'rsuite'

import SearchIconBorder from '../Icons/SearchIconBorder'
import { capitalizeWords } from '../../utils/util'

import styles from '../../styles/Search.module.less'

interface SupplierSuggestionListProps {
  supplierList: {
    label: string
    value: string
    id: string
  }[]
  onSupplierClick: (supplierId: string) => void
}
const SupplierSuggestionList: FC<SupplierSuggestionListProps> = (props) => {
  const { t } = useTranslation('modals')
  const {
    supplierList,
    onSupplierClick,
  } = props

  return supplierList?.map(({ label, id }) => {
    if (label === 'Popular Brands') {
      return (
        <div
          key={label}
          role="option"
          tabIndex={-1}
          aria-selected={false}
        >
          <span className={`rs-auto-complete-item ${styles['search-header']}`}>
            {capitalizeWords(t('Popular brands'))}
          </span>
        </div>
      )
    }
    return (
      <div
        key={label}
        role="option"
        tabIndex={-1}
        aria-selected={false}
        onClick={() => onSupplierClick(id)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            onSupplierClick(id)
          }
        }}
      >
        <span className="rs-auto-complete-item">
          <FlexboxGrid align="middle">
            <FlexboxGrid.Item className="margin-right-spacer">
              <SearchIconBorder />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item className="flex-shrink-1">
              {label}
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </span>
      </div>
    )
  })
}

export default SupplierSuggestionList
